/* eslint-disable react/require-default-props */
import React from 'react';
import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
import './styles.scss';
/**
 * Shared header component for all issue card types
 */
export default function IssueCardHeader({ issueType, badge, isMultitech, technician }) {
    return (React.createElement("div", { className: "issue-card__header" },
        React.createElement("div", { className: "issue-card__header-content" },
            React.createElement("span", { className: "issue-card__type" }, snakeToCapitalize(issueType)),
            badge,
            isMultitech && technician && (React.createElement("div", { className: "issue-card__badges-container" },
                React.createElement("span", { className: "issue-card__multitech" },
                    React.createElement("i", { className: "fa-light fa-user-helmet-safety" }),
                    technician.name))))));
}
